import type { PresetDefinition } from '@wix/wix-data-client-common'
import {
  addOrUpdateRouterWithPattern,
  EDITOR_TYPE,
} from '@wix/wix-data-client-common'
import { generateRouteDefinition } from '../add-dynamic-pages/new-page/generateRouteDefinition'
import type { PageRef } from '@wix/editor-platform-sdk-types'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import type { Schema } from '@wix/wix-data-schema-types'

type PresetRouter = PresetDefinition['routers'][number]

const editorType = EDITOR_TYPE.EDITOR3

export const addRouter = async ({
  editorSdkProxy,
  newCollectionSchema,
  presetRouter,
  presetPageId,
  pageRef,
  pageRole,
  pattern,
  newRouterPrefix,
}: {
  editorSdkProxy: EditorSDK
  newCollectionSchema: Schema
  presetRouter: PresetRouter
  presetPageId: string
  pageRef: PageRef
  pattern: string
  pageRole?: string
  newRouterPrefix: string
}) => {
  const routeDefinition = generateRouteDefinition({
    schema: newCollectionSchema,
    editorType,
    collectionId: newCollectionSchema.id,
    routerConfig: presetRouter!.config,
    routerPages: presetRouter!.pages,
    pageId: presetPageId,
    route: pattern,
    isIndexable: true,
    requiresAdjustingToSchema: true,
    seoV2: true,
    pageRole,
  })

  const routerRef = await addOrUpdateRouterWithPattern(
    editorSdkProxy,
    newRouterPrefix,
    pattern,
    routeDefinition,
  )

  await editorSdkProxy.routers.pages.connect({
    routerRef,
    pageRef,
    pageRoles: [routeDefinition.pageRole],
  })
}
